import {isArrayOrObject, isPlainObject} from "@/utils/helpers";

function getKey(key, parentKey) {
    return parentKey ? `${parentKey}[${key}]` : key;
}

function getParams(data, parentKey) {
    const result = [];

    for(const [key, value] of Object.entries(data)) {
        if (isArrayOrObject(value)) {
            result.push(...getParams(value, getKey(key, parentKey)));
        } else {
            if (typeof value === 'boolean') {
                result.push([getKey(key, parentKey), value]);
            } else {
                if (value) {
                    if (value.toString() === '[object File]') {
                        result.push([getKey(key, parentKey), value]);
                    } else {
                        result.push([getKey(key, parentKey), encodeURIComponent(String(value))]);
                    }
                }
            }
        }
    }

    return result;
}

/**
 * Формирует QueryString из объекта
 * @param {Object} data
 * @returns {String}
 */
export function queryString(data) {
    if (!isPlainObject(data)) {
        throw new Error('аргумент функции не является объектом');
    }

    return '?' + getParams(data).map((arr) => {
        if (typeof arr[1] !== 'string') {
            arr[1] = encodeURIComponent(String(arr[1]))
        }
        arr.join('=')
    }).join('&');
}

/**
 * Формирует FormData из объекта
 * @param {Object} data
 * @returns {FormData}
 */
export default function objectToFormData(data = {}) {
    if (!isPlainObject(data)) {
        throw new Error('аргумент функции не является объектом');
    }

    const params = getParams(data),
        fd = new FormData;

    params.forEach(([key, value]) => {
        if (typeof value === 'string') {
            fd.append(`${key}`, decodeURIComponent(value));
        } else {
            fd.append(`${key}`, value);
        }
    })

    return fd
}
